// @flow
import $ from 'jquery';
import JQueryView, { on } from './JQueryView';

export default class Table extends JQueryView {
  constructor() {
    super('.table-door');
  }

  @on({ event: 'click', selector: 'tr[data-href]' })
  click(e: any) {
    const isLink = $(e.target).hasClass('link');
    if (isLink) return;
    window.location = $(e.currentTarget).data('href');
  }

  @on({ event: 'click', selector: 'tr[data-href-blank]' })
  onClickTrBlank(e: any) {
    const isLink = $(e.target).hasClass('link');
    if (isLink) return;
    window.open($(e.currentTarget).data('href-blank'), '_blank');
  }

  @on({ event: 'click', selector: 'td[data-href]' })
  onClickTd(e: any) {
    const isLink = $(e.target).hasClass('link');
    if (isLink) return;
    window.location = $(e.currentTarget).data('href');
  }

  @on({ event: 'click', selector: 'td[data-href-blank]' })
  onClickTdBlank(e: any) {
    const isLink = $(e.target).hasClass('link');
    if (isLink) return;
    window.open($(e.currentTarget).data('href-blank'), '_blank');
  }

  @on({ event: 'click', selector: 'div[data-href]' })
  clickDiv(e: any) {
    const isLink = $(e.target).hasClass('link');
    if (isLink) return;
    window.location = $(e.currentTarget).data('href');
  }
}
